import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    width: '100%',
});

// The shared `Table` zeroes the inline cell padding, and without a selection column nothing pads the
// first column either, so the edge columns get the same inset the API keys table gives its trailing one.
export const table: TRuleWithTheme = () => ({
    '& .ant-table-thead > tr > th:first-child, & .ant-table-tbody > tr > td:first-child': {
        paddingLeft: '0.75rem',
    },
    '& .ant-table-thead > tr > th:last-child, & .ant-table-tbody > tr > td:last-child': {
        paddingRight: '0.75rem',
    },
});

export const name: TRuleWithTheme = ({ theme }) => ({
    ...theme.typography.ParagraphSmallMedium,

    // The shared Link drops the underline on hover; the design keeps it in both states.
    textDecoration: 'underline',

    ':hover': {
        textDecoration: 'underline',
        color: theme.colors.accentPrimary,
    },
});

// The actions are flex boxes, so they are block-level and the cell's own `text-align` cannot move them.
export const actionsCell: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1rem',
});

export const errorAlert: TRuleWithTheme = () => ({
    '&.ant-alert': {
        marginBottom: 0,
        textAlign: 'center',
    },
});
